import { render, staticRenderFns } from "./EconomicGroups.vue?vue&type=template&id=72507909&scoped=true"
import script from "./EconomicGroups.vue?vue&type=script&lang=js"
export * from "./EconomicGroups.vue?vue&type=script&lang=js"
import style0 from "./EconomicGroups.vue?vue&type=style&index=0&id=72507909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72507909",
  null
  
)

export default component.exports